'use client'

import { Alert } from '@mui/material'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

type SearchEmptyBannerProps = {
  message: string
}

export function SearchEmptyBanner({ message }: SearchEmptyBannerProps) {
  const styles = getStyles(defaultStyles)

  return (
    <Alert severity="error" {...styles('emptyAlert')}>
      {message}
    </Alert>
  )
}
